import React from 'react';
import { List, Popconfirm } from 'antd';
import LinkButton from '../Buttons/LinkButton';
import '../../../src/routes/EventDetail/routes/Media/Media.scss';

export default ({ handlePickItem, item, icon, showThumbnail }) => {
	const type = item.name.split('.')[1];
	if (item.src && showThumbnail) {
		return (
			<Popconfirm
				title="Are you sure you want to select this media?"
				onConfirm={handlePickItem(item)}
				okText="Yes"
				cancelText="No"
				key={item.id}
			>
				<List.Item>
					<div className="card">
						<div className="cardImg">
							{type === 'pdf' ? (
								<iframe src={item.src} style={{ border: 'none' }} width="100%" title="media" />
							) : (
								<img alt={item.name} src={item.src} />
							)}
						</div>
						<div className="cardMeta">
							<p>{item.name}</p>
						</div>
					</div>
				</List.Item>
			</Popconfirm>
		);
	} else {
		return (
			// <Popconfirm
			// 	title="Are you sure you want to select this item?"
			// 	onConfirm={handlePickItem(item)}
			// 	okText="Yes"
			// 	cancelText="No"
			// 	key={item.id}
			// >
			<List.Item
				actions={
					showThumbnail ? false : [<LinkButton onClick={handlePickItem(item)}>Select</LinkButton>]
				}
			>
				<List.Item.Meta
					avatar={icon}
					title={<LinkButton onClick={handlePickItem(item)}>{item.name}</LinkButton>}
					description={item.description ? item.description : ''}
				/>
			</List.Item>
			// </Popconfirm>
		);
	}
};
